import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents, MethodOverview } from './components/MethodOverview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-8 text-center" data-id="element-0" data-mp="31c9u61o04vqe">
    <div className="gold-rule mb-4" aria-hidden="true" data-id="element-1" data-mp="2wjgu3r3habkn">
      <span className="text-brand-gold text-xs" data-id="element-2" data-mp="2whxaprmizken">◆</span>
    </div>
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed" data-id="element-3" data-mp="28t4lsf4bmctj">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen w-full text-brand-text font-sans selection:bg-brand-gold/25 selection:text-brand-purpleDark" data-id="element-4" data-mp="3ij668fcdfvai">
      <UrgencyBanner data-id="element-5" data-mp="3mjg8bgx1m1k3" />
      <main data-id="element-6" data-mp="3rc9hqi3ghy2i">
        <Hero data-id="element-7" data-mp="3rbrakqf99zft" />
        <PackContents data-id="element-8" data-mp="3rdaqgfx028h2" />
        <InitialTestimonials data-id="element-9" data-mp="3rcswjpxt86cb" />
        <PainPoints data-id="element-10" data-mp="3relvsk63foaa" />
        <MethodOverview data-id="element-11" data-mp="6hqtghuuhen" />
        <MoreTestimonials data-id="element-12" data-mp="4ww9qvjiygs" />
        <Guarantee data-id="element-13" data-mp="56l3b4umzkw" />
        <FAQ data-id="element-14" data-mp="7sxbo2oq39g" />
        <CostComparison data-id="element-15" data-mp="2zld2xbxu5jcl" />
        <TransitionPhrase data-id="element-16" data-mp="2zm4yimrfnh2v" />
        <EmotionalClose data-id="element-17" data-mp="2zmwif0bo3qdb" />
      </main>
      <Footer data-id="element-18" data-mp="33moqzd129wio" />
      <FloatingNotification data-id="element-19" data-mp="33m5c656pjo8v" />
    </div>;
}